import { defineComponent as _defineComponent } from 'vue'
import TradingLimits from 'ah-trades/src/components/limitsAndCollateral/TradingLimits.vue';
import PostedCollateral from 'ah-trades/src/components/limitsAndCollateral/PostedCollateral.vue';
import ManageCollateral from 'ah-trades/src/components/limitsAndCollateral/manageCollateral/ManageCollateral.vue';
import { computed, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { ClientRiskProfileReport } from 'ah-api-gateways';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import { useTradeState } from 'ah-trades';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';

// FIXME TileCard used in this component is expected to be setup globally
// Should become an explicit import once BoxGrid family of components is moved to ah-common-lib


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitsAndCollateralManagement',
  props: {
  /**
   * Client ID to display limits and collateral for
   *
   * This component assumes that if there is a clientId assigned, it should display limits and collateral in "read-only" mode
   * Otherwise, owner context will be used (obo client id or session client id)
   */
  clientId: {
    type: String,
  },
},
  setup(__props) {

const props = __props;



const onBehalfOfClient = useOnBehalfOf();

const requestManager = useRequestManager().manager;

const tradeState = useTradeState();

const ownerId = computed(
  () => props.clientId ?? onBehalfOfClient.value?.id ?? tradeState.store.useAuthStore().loggedInIdentity?.client?.id
);

const clientRiskProfileReportData = computed<ClientRiskProfileReport | null>(() =>
  ownerId.value ? tradeState.store.useWalletsStore().getClientRiskProfile(ownerId.value) : null
);

function loadClientRiskProfileReport() {
  // FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE is assumed to be active, as this component only displays if it is
  if (!ownerId?.value) {
    throw 'Cannot load client risk profile report with incomplete data';
  }

  // Load happens with force: true as this component sits at the root of a view
  return requestManager.newPromise(
    'loadClientRiskProfileReport',
    tradeState.store.useWalletsStore().loadClientRiskProfile({ force: true, clientId: ownerId.value })
  );
}

watch(ownerId, () => ownerId.value && loadClientRiskProfileReport(), { immediate: true });

return { __sfc: true,props, onBehalfOfClient, requestManager, tradeState, ownerId, clientRiskProfileReportData, loadClientRiskProfileReport, TradingLimits, PostedCollateral, ManageCollateral, LoadingOverlay }
}

})